import HeadMetadata from 'components/shared/HeadMetadata';
import { LandingSeptiembre25 } from 'features/magnets/septiembre25/LandingSeptiembre25';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type RolesPageProps = WithBaseUrl;

const MangetsIaPage: React.FC<RolesPageProps> = ({ baseUrl }) => {
  const { t } = useI18n('landing-septiembre25');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        url={APP_URLS.landingSeptiembre25}
        title={t('page.title')}
        desc={t('page.description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/septiembre25/card_socials.jpg'
        )}`}
      />

      <LandingSeptiembre25 />
    </>
  );
};

export default MangetsIaPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'landing-septiembre25'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
